var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__photo-24px_2_",
    "data-name": "photo-24px (2)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1001",
    fill: "none",
    d: "M0 0h44v44H0z",
    "data-name": "Path 1001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1002",
    d: "M34.111 6.889v27.222H6.889V6.889h27.222m0-3.889H6.889A3.9 3.9 0 0 0 3 6.889v27.222A3.9 3.9 0 0 0 6.889 38h27.222A3.9 3.9 0 0 0 38 34.111V6.889A3.9 3.9 0 0 0 34.111 3zm-9.45 17.228l-5.833 7.525-4.161-5.036-5.834 7.505h23.334l-7.506-9.994z",
    "data-name": "Path 1002",
    transform: "translate(1.5 1.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo_placeholder.0b49af1705fb0f850ad7881ff1f86ddc.svg";
export { ForwardRef as ReactComponent };